import { useRef } from 'react';
import { CookiePreferences } from './components/CookiePreferences';
import { Footer } from './components/Footer';
import { Header } from './components/Header';
import { useSiteMotion } from './motion/useSiteMotion';
import { HomePage } from './pages/HomePage';
import { LegalPage } from './pages/LegalPage';
import { NotFoundPage } from './pages/NotFoundPage';

export const routes = ['/', '/privacy-policy', '/cookies-policy', '/terms-of-use', '/404'] as const;

export function normalizePath(path: string) {
  if (path === '/index.html' || path === '/index') return '/';
  return path.replace(/\.html$/, '').replace(/\/$/, '') || '/';
}

export function App({ path }: { path: string }) {
  const root = useRef<HTMLDivElement>(null);
  useSiteMotion(root);
  const currentPath = normalizePath(path);
  const isLegal =
    currentPath === '/privacy-policy' ||
    currentPath === '/cookies-policy' ||
    currentPath === '/terms-of-use';
  return (
    <div ref={root}>
      <a className="skip-link" href="#main-content">
        Skip to content
      </a>
      <CookiePreferences />
      <div className="page-wrapper">
        <Header currentPath={currentPath} />
        {currentPath === '/' ? (
          <HomePage />
        ) : isLegal ? (
          <LegalPage
            page={currentPath.slice(1) as 'privacy-policy' | 'cookies-policy' | 'terms-of-use'}
          />
        ) : (
          <NotFoundPage />
        )}
        <Footer />
      </div>
    </div>
  );
}
